<template>
  <v-col cols="12">
    <bar-code-reader
      v-if="dialogRFID"
      @change="leerRFID"
    ></bar-code-reader>
    <template>
    <v-row justify="center">
      <v-dialog v-model="view" persistent max-width="500px">
        <v-card>
            <v-card-title class="headline">Ficha de {{viewedItem.nombre+' '+viewedItem.paterno+' '+viewedItem.materno}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.nombre" label="Nombre"></v-text-field>
                </v-col>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.paterno" label="Apellido Paterno"></v-text-field>
                </v-col>
                    <v-col justify="center" cols="6" sm="6" md="6">
                      <v-text-field readonly v-model="viewedItem.materno" label="Apellido Materno"></v-text-field>
                </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="viewedItem.habilidades"
                    :items="habilidades"
                    label="Habilidades"
                    item-text="nombre"
                    :value-comparator="compararIds"
                    chips
                    multiple
                    readonly
                        item-value="idHabilidad"
                      ></v-autocomplete>
                </v-col>
                    <v-expansion-panels cols="12" sm="12" md="12" multiple accordion>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Máquinas
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-center">Máquina</th>
                              <th class="text-center"># Habilidades</th>
                              <th class="text-center">Porcentaje</th>
                            </tr>
                          </thead>
                          <tbody>
                                <tr v-for="maquina in viewedItem.maquinas" :key="maquina.idMaquina">
                                  <td class="text-center">{{ getNombreMaquina(maquina.idMaquina) }}</td>
                                  <td class="text-center">{{ maquina.nHabilidades }}</td>
                                  <td class="text-center">{{ (maquinas.hRequeridas > 0) ? ((maquina.nHabilidades/maquina.hRequeridas)*100).toFixed(2) : "100.00" }}%</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Moldes
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-simple-table>
                          <thead>
                            <tr>
                              <th class="text-center">Molde</th>
                              <th class="text-center"># Habilidades</th>
                              <th class="text-center">Porcentaje</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="molde in moldesPorOperador(viewedItem)" :key="`molde-${molde.idMolde}`">
                              <td class="text-center">{{ nombreMolde(molde) }}</td>
                              <td class="text-center">{{ molde.nHabilidades }}</td>
                              <td class="text-center">
                                {{ (molde.hRequeridas > 0) ? ((molde.nHabilidades / molde.hRequeridas) * 100).toFixed(2) : "100.00" }}%
                              </td>
                            </tr>
                            <tr v-if="moldesPorOperador(viewedItem).length === 0">
                              <td class="text-center" colspan="3">N/A</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="view = false ">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="pin" persistent max-width="500px">
        <v-card>
          <v-card-title>
              Asignar PIN a {{pinViewed.nombre}} {{pinViewed.materno}} {{pinViewed.paterno}}
          </v-card-title>
          <v-card-text>
              <br>
            <v-col cols="12" md="12" sm="12" class="pa-0 ma-0">
              <v-text-field
                  v-if="pinType == 'numbers'"
                v-model="pinViewed.pin"
                :maxlength="pinLength"
                type="number"
                label="PIN"
                outlined
                ></v-text-field>
              <v-text-field
                  v-if="pinType == 'chars'"
                v-model="pinViewed.pin"
                :maxlength="pinLength"
                label="PIN"
                outlined
                ></v-text-field>
            </v-col>
              <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 text-center justify-center">
                <v-btn
                  color="blue"
                  @click="sugerirPin()"
                  large
                >
                  <v-icon color="white" x-large>mdi-reload</v-icon> Sugerir PIN
              </v-btn>
            </v-col>
            <ul>
                <li v-for="(error,idx) in errores" :key="'error'+idx" class="red--text">{{error}}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="pin=false; pinViewed=Object.assign({},defaultItem);errores=[];">Cancelar</v-btn>
                <v-btn color="red darken-1" text @click="save" :disabled="saving" :loading="saving">
              Guardar
              <template v-slot:loader>
                <v-progress-circular
                  indeterminate
                  :width="2"
                  :size="24"
                  color="red"
                    ></v-progress-circular>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRFID" persistent max-width="500px">
        <v-card>
          <v-card-title>
              Asignar RFID a {{pinViewed.nombre}} {{pinViewed.materno}} {{pinViewed.paterno}}
          </v-card-title>
          <v-card-text>
              <br>
              <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 text-center" >
              <p class="text-h5">Acerque la tarjeta RFID</p>
              <v-progress-circular
                :rotate="-90"
                :size="150"
                :width="15"
                :value="percentRFID"
                color="primary"
              >
                {{ percentRFID }}%
              </v-progress-circular>
            </v-col>
              <br>
            <ul>
                <li v-for="(error,idx) in errores" :key="'error'+idx" class="red--text">{{error}}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="
                    dialogRFID=false;
                rfidsLeidos = [];
                percentRFID = 0;
                errores = [];
                    pinViewed=Object.assign({},defaultItem);
              "
                  >Cancelar</v-btn
                >
                <v-btn color="red darken-1" text :disabled="savingRFID || percentRFID < 100 || saving" @click="saveRFID"  :loading="saving">
              Guardar
              <template v-slot:loader>
                <v-progress-circular
                  indeterminate
                  :width="2"
                  :size="24"
                  color="red"
                    ></v-progress-circular>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="closeAll" persistent max-width="500px">
        <v-card>
            <v-card-title>
            </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="256" color="red">mdi-alert</v-icon>
            </div>
            <div class="red--text title">
              Esta función ejecutara las siguientes acciones:
                <br>
              <ul>
                  <li class="subtitle-2">Desintegrar cualquier Equipo que se encuentre Activo.</li>
                  <li class="subtitle-2">Cerrar las Sesiones de todos los Operadores en las Estaciones de Trabajo.</li>
                  <li class="subtitle-2">Cerrar todas las Operaciones que actualmente se encuentren Ejecutando, reportando un avance de 0.0 (Piezas, Litros, Metros o Cualquier otra Unidad de Medición).</li>
                  <li class="subtitle-2">Recargara la Página de Operaciones de todas las Estaciones de Trabajo que se encuentren encendidas y conectadas.</li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="green" text @click="closeAll = false">Cancelar</v-btn>
              <v-spacer></v-spacer>
            <v-btn color="red" text @click="cerrarTodoRun">Ejecutar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="closeSession" persistent max-width="500px">
        <v-card>
            <v-card-title>
            </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-icon size="256" color="red">mdi-alert</v-icon>
            </div>
            <div class="red--text title">
              Esta función ejecutara las siguientes acciones:
                <br>
              <ul>
                  <li class="subtitle-2">Expulsara a {{logoutItem.nombre}} {{logoutItem.paterno}} {{logoutItem.materno}} de cualquier equipo en donde se encuentre activo.</li>
                  <li class="subtitle-2">Cerrará la Sesión de {{logoutItem.nombre}} {{logoutItem.paterno}} {{logoutItem.materno}} en todas las Estaciones de Trabajo.</li>
                  <li class="subtitle-2">Cerrar todas las Operaciones en donde {{logoutItem.nombre}} {{logoutItem.paterno}} {{logoutItem.materno}} sea el único Operador, reportando un avance de 0.0 (Piezas, Litros, Metros o Cualquier otra Unidad de Medición).</li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
              <v-btn color="green" text @click="closeSession = false">Cancelar</v-btn>
              <v-spacer></v-spacer>
            <v-btn color="red" text @click="cerrarSesionRun">Ejecutar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    </template>
    <v-dialog v-model="dialogQR" max-width="35%" @click:outside="cerrarDialogQR()">
      <v-card>
        <v-card-title class="d-flex justify-center text-center">
          Código QR generado para <br>
          {{
            `${this.pinViewed.nombre} ${this.pinViewed.paterno} ${this.pinViewed.materno}`
          }}
        </v-card-title>
        <v-card-text class="text-center">
          <lottie :options="checkOptions" :height="250" :width="250"/>
          <a class="headline" target="_blank" :href="`/api/Operadores/QROperador/${this.pinViewed.idPersona}`+'?access_token='+token"><v-icon color="primary" large>mdi-download</v-icon> Descargar Código QR</a>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-btn v-if="permisoVista('operadores','d')" color="red" dark block @click="closeAll = true"><v-icon color="yellow">
      mdi-alert</v-icon> Cerrar Todas las Operaciones y Sesiones
    </v-btn>

    <!-- Botón de cambio masivo -->
    <v-btn
      color="orange"
      dark
      block
      large
      class="mb-4"
      @click="dialogCambioMasivo = true"
    >
      <v-icon left>mdi-swap-horizontal</v-icon>
      Cambio Masivo de Turno
    </v-btn>

    <!-- Dialog: cambio masivo -->
    <v-dialog v-model="dialogCambioMasivo" max-width="600px" persistent>
      <v-card>
        <v-card-title class="orange white--text">
          <v-icon left color="white">mdi-swap-horizontal</v-icon>
          Cambio Masivo de Turno
                <v-spacer />

      <!-- X para cerrar -->
      <v-btn
        icon
        color="white"
        @click="cerrarDialogCambioMasivo"
        aria-label="Cerrar"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
        </v-card-title>

        

        <v-card-text class="pt-4">
          <v-row>
            <!-- Opción 1 -->
            <v-col cols="12">
              <v-switch
                v-model="cambioMasivo.todos"
                label="Cambiar TODOS los operadores (60)"
                color="orange"
                @change="onTodosChange"
              />
            </v-col>

            <!-- Opción 2 -->
            <v-col cols="12" v-if="!cambioMasivo.todos">
              <v-select
                v-model="cambioMasivo.turnoOrigen"
                :items="turnos"
                item-text="nombre"
                item-value="idTurno"
                label="Desde Turno (origen)"
                outlined
                clearable
                hint="Dejar vacío para seleccionar operadores manualmente"
                persistent-hint
                @change="cargarOperadoresPorTurno"
              >
                <template v-slot:prepend>
                  <v-icon color="orange">mdi-arrow-right-circle-outline</v-icon>
                </template>
              </v-select>
            </v-col>

            <!-- Opción 3 -->
            <v-col
              cols="12"
              v-if="!cambioMasivo.todos && !cambioMasivo.turnoOrigen"
            >
            <v-autocomplete
              v-model="cambioMasivo.operadoresSeleccionados"
              :items="personas"
              :item-text="getOperadorNombre"
              item-value="idPersona"
              label="Seleccionar Operadores Manualmente"
              outlined
              multiple
              chips
              deletable-chips
              @change="onManualChange"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 3"
                  small
                  close
                  color="orange lighten-4"
                  text-color="orange darken-3"
                  @click:close="removeOperador(item.idPersona)"
                >
                  <v-icon left small color="orange darken-2">mdi-account</v-icon>
                  {{ item.nombre }} {{ item.paterno }}
                </v-chip>

                <span v-if="index === 3" class="grey--text text-caption">
                  (+{{ cambioMasivo.operadoresSeleccionados.length - 3 }} más)
                </span>
              </template>
            </v-autocomplete>

            </v-col>

            <v-divider class="mx-4" />

            <!-- Turno destino -->
            <v-col cols="12">
              <v-select
                v-model="cambioMasivo.turnoDestino"
                :items="turnos"
                item-text="nombre"
                item-value="idTurno"
                label="A Turno (destino)"
                outlined
                :rules="[(v) => !!v || 'Requerido']"
              >
                <template v-slot:prepend>
                  <v-icon color="green">mdi-check-circle-outline</v-icon>
                </template>
              </v-select>
            </v-col>

            <!-- Preview -->
            <v-col cols="12" v-if="cantidadAfectados > 0">
              <v-alert type="info" dense text prominent border="left">
                <v-row align="center">
                  <v-col class="grow">
                    Se cambiarán <strong>{{ cantidadAfectados }} operadores</strong>
                    <span v-if="cambioMasivo.turnoOrigen">
                      del <strong>{{ getNombreTurno(cambioMasivo.turnoOrigen) }}</strong>
                    </span>
                    al <strong>{{ getNombreTurno(cambioMasivo.turnoDestino) }}</strong>
                  </v-col>

                  <v-col class="shrink">
                    <v-btn
                      small
                      text
                      color="primary"
                      @click="mostrarPreview = !mostrarPreview"
                    >
                      {{ mostrarPreview ? 'Ocultar' : 'Ver' }} lista
                      <v-icon right>
                        {{ mostrarPreview ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>

              <v-expand-transition>
                <v-card v-show="mostrarPreview" outlined class="mt-2">
                  <v-card-text style="max-height: 300px; overflow-y: auto">
                    <v-list dense>
                      <v-list-item
                        v-for="op in operadoresAfectados"
                        :key="op.idPersona"
                        two-line
                      >
                        <v-list-item-avatar color="orange lighten-4">
                          <span class="orange--text text--darken-2">
                            {{ op.nombre[0] }}{{ op.paterno[0] }}
                          </span>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title>
                            {{ op.nombre }} {{ op.paterno }} {{ op.materno }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-chip x-small color="orange lighten-4" text-color="orange darken-3" class="mr-2">
                              <v-icon left x-small>mdi-arrow-right</v-icon>
                              {{ op.turno || 'Sin turno' }}
                            </v-chip>

                            <v-icon small color="grey">mdi-arrow-right</v-icon>

                            <v-chip x-small color="green lighten-4" text-color="green darken-3" class="ml-2">
                              {{ getNombreTurno(cambioMasivo.turnoDestino) }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-expand-transition>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn text @click="cerrarDialogCambioMasivo">Cancelar</v-btn>
          <v-spacer />
          <v-btn
            color="orange"
            :disabled="!puedeEjecutar"
            :loading="ejecutando"
            @click="ejecutarCambioMasivo"
          >
            <v-icon left>mdi-check-bold</v-icon>
            Ejecutar Cambio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog asignación de máquinas logeables -->
    <v-dialog v-model="dialogAccesoMaquinas" persistent max-width="720px">
      <v-card>
        <v-card-title>
          Acceso a máquinas de {{ operadorMaquinas.nombre }} {{ operadorMaquinas.paterno }} {{ operadorMaquinas.materno }}
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="searchMaquinas"
            label="Filtrar máquinas"
            append-icon="search"
            clearable
            dense
            outlined
            hide-details
            class="mb-4"
          />
          <v-progress-linear
            v-if="loadingMaquinas"
            indeterminate
            color="primary"
            class="mb-4"
          />
          <v-alert
            v-else-if="maquinas.length === 0"
            type="info"
            outlined
            dense
            class="mb-0"
          >
            No hay máquinas disponibles para mostrar.
          </v-alert>
          <div
            v-else
            style="max-height: 55vh; overflow-y: auto;"
          >
            <v-list dense class="py-0">
              <v-list-item
                v-for="maquina in maquinasFiltradas"
                :key="maquina.idMaquina"
                class="px-0"
              >
                <v-list-item-action class="mr-3">
                  <v-checkbox
                    v-model="maquinasLogPermitido"
                    :value="Number(maquina.idMaquina)"
                    hide-details
                    class="mt-0"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ getNombreMaquina(maquina.idMaquina) || `Maquina ${maquina.idMaquina}` }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="cerrarAsignarMaquinas" color="success" text>Cancelar</v-btn>
          <v-btn
            @click="guardarAsignarMaquinas"
            color="error"
            :loading="savingMaquinas"
            :disabled="savingMaquinas || loadingMaquinas || !operadorMaquinas.idPersona"
          >
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tabla -->
    <v-data-table
      v-if="permisoVista('operadores','r')"
      :headers="headers"
      :items="personas"
      :search="search"
      :loading="loading"
      loading-text="Cargando... Espere, Por Favor."
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-tooltip v-if="permisoVista('operadores','r') && qrOperador"  bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on"
              small
              class="mr-2"
              @click="showDialogQR(item)"
            >
              mdi-qrcode
            </v-icon>
          </template>
          <span class="white--text">Generar código QR</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
          v-if="permisoVista('operadores','u') && rfid"
              small
              class="mr-2"
              @click="rfidView(item)"
            >
              mdi-credit-card
            </v-icon>
          </template>
          <span class="white--text">Asignar RFID</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
          v-if="permisoVista('operadores','u') && !rfid && !qrOperador"
              small
              class="mr-2"
              @click="pinView(item)"
            >
              mdi-key
            </v-icon>
          </template>
          <span class="white--text">Asignar PIN</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
          v-if="permisoVista('operadores','d')"
              small
              class="mr-2"
              @click="cerrarSesion(item)"
            >
              mdi-ethernet-cable-off
            </v-icon>
          </template>
          <span class="white--text">Cerrar Sesion y Operaciones</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
          v-if="permisoVista('operadores','r')"
              small
              class="mr-2"
              @click="viewItem(item)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span class="white--text">Ver detalles</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" v-if="permisoVista('operadores','u')" small class="mr-2" @click="asignarMaquinas(item)">
              mdi-robot-industrial
            </v-icon>
          </template>
          <span class="white--text">Acceso a máquinas</span>
        </v-tooltip>
      </template>
      <template v-slot:item.pin="{ item }" >
        <div class="text-center">
          {{ getTextoColumna(item) }}
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Refrescar</v-btn>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="2500" top right>
      <v-icon left color="white">
        {{ snackbarColor === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
      </v-icon>
      {{ snackbarText }}
    </v-snackbar>
  </v-col>
</template>


<script>
import axios from "axios";
import { mapState } from "vuex";
import BarCodeReader from '../../BarCodeReader.vue';
import moment from 'moment';
import Lottie from 'vue-lottie';
import * as checkData from '@/assets/qr-scanning.json';

  export default {
    components: {
      "bar-code-reader": BarCodeReader,
      'lottie': Lottie
    },
    data: () => ({
      checkOptions: {
        animationData: checkData.default,
        loop:true,
        speeed: 0.5
      },
      rfidsLeidos: [],
      percentRFID: 0,
      view:false,
      saving:false,
      savingRFID:false,
      viewedItem:[],
      search: '',
      loading: false,
      habilidades: [],
      loadingHabilidades: false,
      moldes: [],
      loadingMoldes: false,
      personas: [],
      pin:false,
      defaultItem: {
        idPersona: 0,
        pin:'',
        nombre:'',
        paterno:'',
        materno:'',
      },
      pinViewed:{
        idPersona: 0,
        pin:'',
        nombre:'',
        paterno:'',
        materno:'',
      },
      errores:[],
      closeAll:false,
      closeSession:false,
      logoutItem:{
        idPersona: 0,
        pin:'',
        nombre:'',
        paterno:'',
        materno:'',
      },
      dialogCambioMasivo: false,
      ejecutando: false,
      mostrarPreview: false,
      cambioMasivo: {
      todos: false,
      turnoOrigen: null,
      turnoDestino: null,
      operadoresSeleccionados: []
    },
    operadoresAfectados: [],
    turnos: [],
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success',

    dialogAccesoMaquinas: false,
    savingMaquinas: false,
    operadorMaquinas: {
      idPersona: 0,
      nombre: '',
      paterno: '',
      materno: '',
    },
    maquinasLogPermitido: [],
    maquinasLogPermitidoOriginal: [],
    searchMaquinas: '',
    }),

    computed: {
      ...mapState(["pinType","pinLength","rfid","qrOperador","token"]),
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Operador' : 'Editar Operador'
      },
      headers(){
        return [
          {
            text: 'Nombre',
            align: 'left',
            sortable: true,
            value: 'nombre',
          },
          {
            text: 'Paterno',
            align: 'left',
            sortable: true,
            value: 'paterno',
          },
          {
            text: 'Materno',
            align: 'left',
            sortable: true,
            value: 'materno',
          },
          {
            text: 'Turno',
            align: 'left',
            sortable: true,
            value: 'turno',
          },
          {
            text: this.getTextoHeader(),
            align: 'center',
            sortable: true,
            value: 'pin',
          },
          { text: 'Acciones', value: 'action', sortable: false, width:'20%', align:'center' },
        ]
      },
      cantidadAfectados() {
      if (this.cambioMasivo.todos) {
        return this.personas.length;
      } else if (this.cambioMasivo.turnoOrigen) {
        return this.personas.filter(p => p.idTurno === this.cambioMasivo.turnoOrigen).length;
      } else {
        return this.cambioMasivo.operadoresSeleccionados.length;
      }
    },

    puedeEjecutar() {
      return this.cambioMasivo.turnoDestino && this.cantidadAfectados > 0;
    },

    maquinasFiltradas() {
      const filtro = (this.searchMaquinas || '').trim().toLowerCase();
      if (!filtro) {
        return this.maquinas;
      }

      return (this.maquinas || []).filter((maquina) => {
        const nombre = this.getNombreMaquina(maquina.idMaquina) || `Maquina ${maquina.idMaquina}`;
        return nombre.toLowerCase().includes(filtro);
      });
    }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    mounted () {
      this.initialize();
      this.cargarTurnos();
    },

    methods: {
      getTextoHeader(){
        return (this.rfid || this.qrOperador) 
          ? this.rfid 
            ? '¿Tiene Tarjeta Asignada?'
            : '¿Tiene Código QR Asignado?'
          : 'PIN';
      },
      getTextoColumna(item){
        if(this.rfid || this.qrOperador){
          return item.pin == null ? 'No' : 'Si';
        }
        else{
          return item.pin;
        }
      },
      leerRFID(rfid){
        if ( this.$utils.strings.isOnlyNumbers(rfid) ){
          if ( this.rfidsLeidos.length < 3 ){
            if( this.rfidsLeidos.length === 0 ) {
              this.rfidsLeidos.push(rfid);
              this.percentRFID += 33;
            }
            else if ( this.rfidsLeidos.length === 1 ){
              if ( this.rfidsLeidos[0] == rfid ){
                this.rfidsLeidos.push(rfid);
                this.percentRFID += 33;
              }
            }
            else if ( this.rfidsLeidos.length === 2 ){
              if ( this.rfidsLeidos[1] == rfid ){
                this.rfidsLeidos.push(rfid);
                this.percentRFID += 34;
              }
            }
          }
        }
      },
      async initialize() {
        this.getHabilidades();
        this.getMaquinas();
        this.getMoldes();
        this.loading = true;

        try {
          const { data } = await axios.get("/Personas/Operadores");
          this.personas = this.normalizarPersonas(data);

        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },

      cerrarTodoRun(){
        axios
          .get("/Operadores/LogoutForzadoMasivo")
          .then(() => {})
          .catch(error => {
            console.log(error);
          });
        this.closeAll = false;
      },
      cerrarSesion(item){
        this.logoutItem = Object.assign({},item);
        this.closeSession = true;
      },
      cerrarSesionRun(){
        axios
          .get("/Operadores/LogoutForzadoOperador/"+this.logoutItem.idPersona)
          .then(() => {})
          .catch(error => {
            console.log(error);
          });
        this.closeSession = false;
      },
      getNombreMaquina(idMaquina){
        var m = this.maquinas.find(x => x.idMaquina == idMaquina);
        if(m != null) return m.marca+" "+m.modelo;
        else return "";
      },
      getHabilidades (){
        let me = this;
        me.loadingHabilidades = true;
        axios
        .get("/Habilidades")
        .then(response =>  {
          me.habilidades = (Array.isArray(response.data) ? response.data : []).map((h) => ({
            ...h,
            idHabilidad: Number(h.idHabilidad ?? h.IdHabilidad),
          }));
          me.loadingHabilidades = false;
        })
        .catch(error => {
          me.loadingHabilidades = false;
          console.log(error);
        });
      },
      getMaquinas (){
        let me = this;
        me.loadingMaquinas = true;
        axios
        .get("/Maquinas/Basico")
        .then(response =>  {
          me.maquinas = response.data;
          me.loadingMaquinas = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getMoldes() {
        this.loadingMoldes = true;
        axios
        .get("/Moldes")
        .then(response =>  {
          const catalogoHabilidades = Array.isArray(this.habilidades) ? this.habilidades : [];
          const toNumSet = (items) => new Set(this.toNumArray(items, "idHabilidad"));

          this.moldes = (Array.isArray(response.data) ? response.data : []).map((molde) => {
            const habilidadesRaw = Array.isArray(molde.habilidades)
              ? molde.habilidades
              : Array.isArray(molde.Habilidades)
                ? molde.Habilidades
                : Array.isArray(molde.IdsHabilidad)
                  ? molde.IdsHabilidad
                  : Array.isArray(molde.IdsHabilidades)
                    ? molde.IdsHabilidades
                : Array.isArray(molde.idsHabilidad)
                  ? molde.idsHabilidad
                  : Array.isArray(molde.idsHabilidades)
                    ? molde.idsHabilidades
                    : [];

            const idsHabilidades = toNumSet(habilidadesRaw);
            const habilidades = catalogoHabilidades.length
              ? catalogoHabilidades.filter((h) => idsHabilidades.has(Number(h.idHabilidad)))
              : habilidadesRaw;

            return {
              ...molde,
              habilidades,
            };
          });
          this.loadingMoldes = false;
        })
        .catch(error => {
          this.moldes = [];
          this.loadingMoldes = false;
          console.log(error);
        });
      },
      toNumArray(items, key = null) {
        if (!Array.isArray(items)) return [];
        return items
          .map((item) => {
            if (!(key && item && typeof item === "object")) return item;
            const keyUpper = key.charAt(0).toUpperCase() + key.slice(1);
            return item[key] ?? item[keyUpper];
          })
          .map((item) => Number(item))
          .filter((item) => Number.isFinite(item) && item > 0);
      },
      idsHabilidadesPersona(persona) {
        if (!persona) return [];
        const raw = Array.isArray(persona.habilidades)
          ? persona.habilidades
          : Array.isArray(persona.Habilidades)
            ? persona.Habilidades
            : Array.isArray(persona.idsHabilidad)
              ? persona.idsHabilidad
              : Array.isArray(persona.IdsHabilidad)
                ? persona.IdsHabilidad
                : Array.isArray(persona.idsHabilidades)
                  ? persona.idsHabilidades
                  : Array.isArray(persona.IdsHabilidades)
                    ? persona.IdsHabilidades
                    : [];
        return this.toNumArray(raw, "idHabilidad");
      },
      normalizarPersonas(personasRaw) {
        if (!Array.isArray(personasRaw)) return [];
        return personasRaw.map((persona) => {
          const habilidades = this.idsHabilidadesPersona(persona);
          return {
            ...persona,
            habilidades,
          };
        });
      },
      compararIds(a, b) {
        return Number(a) === Number(b);
      },
      nombreMolde(molde) {
        if (!molde) return "N/A";
        const codigo = molde.codigo ? `[${molde.codigo}] ` : "";
        const nombre = molde.nombre || molde.tituloProducto || "Molde";
        return `${codigo}${nombre}`.trim();
      },
      moldesPorOperador(persona) {
        if (!persona) return [];
        const habilidadesPersona = new Set(this.idsHabilidadesPersona(persona));
        const resultado = (this.moldes || [])
          .map((molde) => {
            const habilidadesRaw = Array.isArray(molde.habilidades)
              ? molde.habilidades
              : Array.isArray(molde.Habilidades)
                ? molde.Habilidades
                : Array.isArray(molde.IdsHabilidad)
                  ? molde.IdsHabilidad
                  : Array.isArray(molde.IdsHabilidades)
                    ? molde.IdsHabilidades
                    : [];
            const habilidadesMolde = this.toNumArray(habilidadesRaw, "idHabilidad");
            const hRequeridas = habilidadesMolde.length;
            const nHabilidades = habilidadesMolde.filter((id) => habilidadesPersona.has(id)).length;
            return {
              ...molde,
              hRequeridas,
              nHabilidades,
            };
          })
          .filter((molde) => molde.hRequeridas > 0)
          .sort((a, b) => b.nHabilidades - a.nHabilidades);
        return resultado;
      },
      cerrarDialogQR(){
        this.dialogQR = false;
        this.pinViewed = Object.assign({},this.defaultItem);
        this.initialize();
      },
      descargarQR(){
        var datetime = moment().format('YYYYMMDDHHmmss');
        this.$utils.axios.downloadFile(`/Operadores/QROperador/${this.pinViewed.idPersona}`,'GET',`qr-${this.viewedItem.nombre}-${this.viewedItem.paterno}-`+datetime+'.pdf','application/pdf');
      },
      showDialogQR(item){
        this.pinViewed = Object.assign({},item);
        this.dialogQR = true;
      },
      viewItem (item) {
        this.viewedIndex = this.personas.indexOf(item)
        this.viewedItem = Object.assign({}, item)
        this.viewedItem.habilidades = this.idsHabilidadesPersona(item);
        this.view = true
      },
      asignarMaquinas(item) {
        this.operadorMaquinas = Object.assign({}, item);
        this.maquinasLogPermitido = this.obtenerIdsMaquinasLogPermitido(item);
        this.maquinasLogPermitidoOriginal = [...this.maquinasLogPermitido];
        this.searchMaquinas = '';
        this.dialogAccesoMaquinas = true;
      },
      cerrarAsignarMaquinas() {
        this.maquinasLogPermitido = [...this.maquinasLogPermitidoOriginal];
        this.searchMaquinas = '';
        this.operadorMaquinas = {
          idPersona: 0,
          nombre: '',
          paterno: '',
          materno: '',
        };
        this.savingMaquinas = false;
        this.dialogAccesoMaquinas = false;
      },
      obtenerIdsMaquinasLogPermitido(persona) {
        if (!persona) return [];

        const raw = Array.isArray(persona.maquinasLogPermitido)
          ? persona.maquinasLogPermitido
          : Array.isArray(persona.MaquinasLogPermitido)
            ? persona.MaquinasLogPermitido
            : Array.isArray(persona.idsMaquinasLogPermitido)
              ? persona.idsMaquinasLogPermitido
              : Array.isArray(persona.IdsMaquinasLogPermitido)
                ? persona.IdsMaquinasLogPermitido
                : [];

        return raw
          .map((maquina) => {
            if (maquina && typeof maquina === "object") {
              return maquina.idMaquina ?? maquina.IdMaquina ?? maquina.id ?? maquina.Id;
            }
            return maquina;
          })
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id) && id > 0);
      },
      async guardarAsignarMaquinas() {
        if (!this.operadorMaquinas.idPersona) return;

        this.savingMaquinas = true;

        try {
          await axios.put(
            `/Personas/ActualizarMaquinasOperador/${this.operadorMaquinas.idPersona}`,
            [...new Set(this.maquinasLogPermitido.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))]
          );

          this.snackbarColor = "success";
          this.snackbarText = "Se actualizaron las máquinas del operador";
          this.snackbar = true;

          this.cerrarAsignarMaquinas();

          const { data } = await axios.get("/Personas/Operadores", { params: { t: Date.now() } });
          this.personas = this.normalizarPersonas(data);
          this.initialize();
        } catch (error) {
          this.snackbarColor = "error";
          this.snackbarText =
            error.response?.data?.message ||
            error.message ||
            "No se pudo actualizar el acceso a máquinas";
          this.snackbar = true;
          console.log(error);
        } finally {
          this.savingMaquinas = false;
        }
      },
      pinView(item){
        this.pinViewed = Object.assign({},item);
        this.pin = true;
      },
      rfidView(item){
        this.pinViewed = Object.assign({},item);
        this.dialogRFID = true;
      },
      sugerirPin(){
        axios
        .get("/Personas/SugererPIN")
        .then(response => {
          this.pinViewed.pin = response.data;
        })
        .catch(error => {
          console.log(error);
        })
      },
      saveRFID(){
        this.pinViewed.pin = this.rfidsLeidos[0];
        this.save();
      },
      save(){
        this.errores = [];
        if(this.pinViewed.pin.length != this.pinLength){
          this.errores.push(`El Pin debe de ser de ${this.pinLength} Dígitos`);
          return;
        }
        if(!this.rfid){
          var reg = /^\d+$/;
          if(!reg.test(this.pinViewed.pin)){
            this.errores.push("El Pin debe de estar formado solo por Números");
          }
        }
        this.saving = true;
        axios
        .put("/Personas/ActualizarPIN",{
          IdOperador: this.pinViewed.idPersona,
          Pin: this.pinViewed.pin
        })
        .then(response => {
          this.saving = false;
          this.pin = false;
          this.dialogRFID = false;
          this.rfidsLeidos = [];
          this.percentRFID = 0;
          this.errores = [];
          this.pinViewed=Object.assign({}, this.defaultItem);
          axios
          .get("/Personas/Operadores")
          .then(response =>  {
            this.personas = this.normalizarPersonas(response.data);
            this.loading = false;
          })
          .catch(error => {
            console.log(error);
          });
        })
        .catch(error => {
          this.saving = false;
          if(error.response.status == 409){
            this.errores = [];
            this.errores.push("Este PIN es usado por otro Operador");
          }
          console.log(error);
        })
      },
      close () {
        this.action = 0,
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      async cargarTurnos() {
      try {
        const response = await axios.get('/Turnos');
        this.turnos = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    onManualChange() {
      this.operadoresAfectados = this.personas.filter(p =>
        this.cambioMasivo.operadoresSeleccionados.includes(p.idPersona)
      );
      this.mostrarPreview = this.operadoresAfectados.length > 0;
    },


    onTodosChange() {
      if (this.cambioMasivo.todos) {
        this.cambioMasivo.turnoOrigen = null;
        this.cambioMasivo.operadoresSeleccionados = [];
        this.operadoresAfectados = this.personas;
      } else {
        this.operadoresAfectados = [];
      }
    },

    cargarOperadoresPorTurno() {
      if (this.cambioMasivo.turnoOrigen) {
        this.operadoresAfectados = this.personas.filter(
          p => p.idTurno === this.cambioMasivo.turnoOrigen
        );
        this.cambioMasivo.operadoresSeleccionados = [];
      } else {
        this.operadoresAfectados = [];
      }
    },

    getOperadorNombre(operador) {
      return `${operador.nombre} ${operador.paterno} ${operador.materno} - ${operador.turno || 'Sin turno'}`;
    },

    getNombreTurno(idTurno) {
      const turno = this.turnos.find(t => t.idTurno === idTurno);
      return turno ? turno.nombre : '';
    },

    removeOperador(idPersona) {
      const index = this.cambioMasivo.operadoresSeleccionados.indexOf(idPersona);
      if (index >= 0) {
        this.cambioMasivo.operadoresSeleccionados.splice(index, 1);
      }
      this.onManualChange();
    },
    async ejecutarCambioMasivo() {
      this.ejecutando = true;

      try {
        let idsPersonas = [];

        if (this.cambioMasivo.todos) {
          idsPersonas = this.personas.map(p => p.idPersona);
        } else if (this.cambioMasivo.turnoOrigen) {
          idsPersonas = this.personas
            .filter(p => p.idTurno === this.cambioMasivo.turnoOrigen)
            .map(p => p.idPersona);
        } else {
          idsPersonas = [...this.cambioMasivo.operadoresSeleccionados];
        }

        if (!idsPersonas.length) throw new Error("No hay operadores seleccionados");

        await axios.put('/Turnos/CambioMasivo', {
          turnoOrigenId: this.cambioMasivo.turnoOrigen,
          turnoDestinoId: this.cambioMasivo.turnoDestino,
          idsPersonas,
          todosLosOperadores: this.cambioMasivo.todos
        });
        this.snackbarColor = 'success';
        this.snackbarText = `¡Listo! Se actualizaron ${idsPersonas.length} operadores`;
        this.snackbar = true;

        await axios.get("/Personas/Operadores", { params: { t: Date.now() } })
          .then(r => { this.personas = this.normalizarPersonas(r.data); });

        await this.$nextTick();

        this.cerrarDialogCambioMasivo();

      } catch (error) {
        this.snackbarColor = 'error';
        this.snackbarText =
          error.response?.data?.message ||
          error.message ||
          "No se pudo completar el cambio";
        this.snackbar = true;
      } finally {
        this.ejecutando = false;
      }
    },
    cerrarDialogCambioMasivo() {
      this.dialogCambioMasivo = false;

      this.cambioMasivo = {
        todos: false,
        turnoOrigen: null,
        turnoDestino: null,
        operadoresSeleccionados: []
      };

      this.operadoresAfectados = [];
      this.mostrarPreview = false;
      this.$nextTick(() => {
        this.dialogCambioMasivo = false;
      });
    }
    },
  }
</script>
